export const voiceQuestions = [
  {
    id: 1,
    koreanQuestion:
      "회사의 최근 성공으로 인해, 모든 직원들이  ______  급여 인상을  부분으로서 새로운 보상 계획의",
    question:
      "Due to the company's recent success, all employees _____ a salary increase as part of the new compensation plan.",
    choices: {
      A: "promised",
      B: "were promised",
    },
    correctAnswer: "B",
    explanation: "A: 직원들이 약속 했다 B: 직원들이 약속 받았다",
    translation:
      "회사의 최근 성공으로 인해 모든 직원들이 새로운 보상 계획의 일환으로 급여 인상을 약속받았다.",
    type: "voice",
  },
  {
    id: 2,
    koreanQuestion:
      "그 회사는 _____ 혁신적인 전략들에 유지하기 위해서 경쟁력을 시장에서",
    question:
      "The company _____ on innovative strategies to remain competitive in the market.",
    choices: {
      A: "is depended",
      B: "depends",
    },
    correctAnswer: "B",
    explanation:
      "A: 회사는 의존되어 진다 혁신적인 전략들에 B: 회사는 의존한다 혁신적인 전략들에 ",
    translation:
      "그 회사는 시장에서 경쟁력을 유지하기 위해 혁신적인 전략들에 의존한다.",
    type: "verb form",
  },
  {
    id: 3,
    koreanQuestion:
      "배송 추적 시스템에 따르면, 화물이 _______ 고객의 주소로 일찍 오늘 아침",
    question:
      "According to the tracking system, the shipment _____ to the customer's address early this morning.",
    choices: {
      A: "sent",
      B: "was sent",
    },
    correctAnswer: "B",
    explanation:
      "A: 화물이 보냈다 고객의 주소로 B: 화물이 보내졌다 고객의 주소로",
    translation:
      "배송 추적 시스템에 따르면, 화물이 오늘 아침 일찍 고객의 주소로 발송되었다.",
    type: "voice",
  },
  {
    id: 4,
    koreanQuestion:
      "연례 회의 동안, 각 프로젝트 매니저가 _______ 특정 책임들을 다가오는 분기를 위한",
    question:
      "During the annual meeting, each project manager _____ specific responsibilities for the upcoming quarter.",
    choices: {
      A: "assigned",
      B: "was assigned",
    },
    correctAnswer: "B",
    explanation:
      "A: 프로젝트 매니저가 배정했다 특정 책임들을 B: 프로젝트 매니저가 배정받았다 특정 책임들을",
    translation:
      "연례 회의 동안, 각 프로젝트 매니저가 다가오는 분기를 위한 특정 책임들을 배정받았다.",
    type: "voice",
  },
  {
    id: 5,
    koreanQuestion:
      "물류 회사가 _______  모든 필요한 자재를 건설 현장으로 일정보다 앞서",
    question:
      "The logistics company _____ all necessary materials to the construction site ahead of schedule.",
    choices: {
      A: "delivered",
      B: "was delivered",
    },
    correctAnswer: "A",
    explanation:
      "A: 물류 회사가 배송했다 모든 필요한 자재를 B: 물류 회사가 배송되었다 모든 필요한 자재를",
    translation:
      "물류 회사가 일정보다 앞서 모든 필요한 자재를 건설 현장으로 배송했다.",
    type: "voice",
  },
  {
    id: 6,
    koreanQuestion:
      "완료하기 위해 거래를, 고객이 ____ 영수증을 확인하면서 결제를",
    question:
      "To complete the transaction, the customer _____ a receipt confirming the payment.",
    choices: {
      A: "handed",
      B: "was handed",
    },
    correctAnswer: "B",
    explanation: "A: 고객이 건넸다 영수증을 B: 고객이 건네받았다 영수증을",
    translation:
      "거래를 완료하기 위해, 고객이 결제를 확인하는 영수증을 건네받았다.",
    type: "voice",
  },
  {
    id: 7,
    koreanQuestion:
      "확실히하기 위해  빠른 응답을, 비서가 ___ 긴급 이메일을 매니저에게 즉시",
    question:
      "To ensure a quick response, the secretary _____ the urgent email to the manager immediately.",
    choices: {
      A: "forwarded",
      B: "was forwarded",
    },
    correctAnswer: "A",
    explanation:
      "A: 비서가 전달했다 긴급 이메일을 B: 비서가 전달받았다 긴급 이메일을",
    translation:
      "확실히하기 위해, 빠른 응답을 위해, 비서가 긴급 이메일을 즉시 매니저에게 전달했다.",
    type: "voice",
  },
  {
    id: 8,
    koreanQuestion:
      "회의가 끝날 때, 최종 버전이 보고서 _____ 이사회 구성원들에게 승인을 위해",
    question:
      "At the end of the meeting, the final version of the report _____ to the board members for approval.",
    choices: {
      A: "passed",
      B: "was passed",
    },
    correctAnswer: "B",
    explanation:
      "A: 보고서 최종 버전이 전달했다 이사회 구성원들에게 B: 보고서 최종 버전이 전달되었다 이사회 구성원들에게",
    translation:
      "회의가 끝날 때, 보고서의 최종 버전이 승인을 위해 이사회 구성원들에게 전달되었다.",
    type: "voice",
  },
  {
    id: 9,
    koreanQuestion: "그의 뛰어난 성과로 인해, 직원이  _______  추가 휴가를",
    question:
      "Due to his outstanding performance, the employee _____ an extra day off.",
    choices: {
      A: "was allowed",
      B: "allowed",
    },
    correctAnswer: "A",
    explanation:
      "A: 직원이 허가받았다 추가 휴가를 B: 직원이 허가했다 추가 휴가를",
    translation:
      "그의 뛰어난 성과로 인해, 직원이 하루의 추가 휴가를 허가받았다.",
    type: "voice",
  },
  {
    id: 10,
    koreanQuestion:
      "제출 후에 모든 요구되는 서류들을, 지원자는  _______  비자를 들어가기 위해 그 나라에",
    question:
      "After submitting all the required documents, the applicant _____ a visa to enter the country.",
    choices: {
      A: "granted",
      B: "was granted",
    },
    correctAnswer: "B",
    explanation: "A: 지원자가 허가했다 비자를 B: 지원자가 허가받았다 비자를",
    translation:
      "모든 필요 서류를 제출한 후, 지원자가 그 나라에 입국하기 위한 비자를 발급받았다.",
    type: "voice",
  },
  {
    id: 11,
    koreanQuestion: "불완전한 정보로 인해, 고객의 요청이  _______  은행에 의해",
    question:
      "Because of incomplete information, the customer's request _____ by the bank.",
    choices: {
      A: "denied",
      B: "was denied",
    },
    correctAnswer: "B",
    explanation: "A: 고객의 요청이 거부했다 B: 고객의 요청이 거부되었다",
    translation: "불완전한 정보로 인해, 고객의 요청이 은행에 의해 거부되었다.",
    type: "voice",
  },
  {
    id: 12,
    koreanQuestion:
      "시상식이 끝날 때, 우승 팀이 _______  트로피를 그들의 성과에 대해",
    question:
      "At the end of the ceremony, the winning team _____ a trophy for their achievement.",
    choices: {
      A: "awarded",
      B: "was awarded",
    },
    correctAnswer: "B",
    explanation:
      "A: 우승 팀이  수여했다 트로피를  B: 우승 팀이 수여받았다 트로피를 ",
    translation:
      "시상식이 끝날 때, 우승 팀이 그들의 성과에 대해 트로피를 수여받았다.",
    type: "voice",
  },
  {
    id: 13,
    koreanQuestion:
      " 늦은 결제로 인해, 고객이 _______  추가 서비스 요금을 다음 청구 주기에",
    question:
      "Due to late payment, the customer _____ an additional service fee on the next billing cycle.",
    choices: {
      A: "charged",
      B: "was charged",
    },
    correctAnswer: "B",
    explanation:
      "A: 고객이 부과했다 추가 서비스 요금을 B: 고객이 부과받았다 추가 서비스 요금을",
    translation:
      "늦은 결제로 인해, 고객이 다음 청구 주기에 추가 서비스 요금을 부과받았다.",
    type: "voice",
  },
  {
    id: 14,
    koreanQuestion:
      "주차 규정 위반으로 인해, 운전자가  _______  벌금을 200달러",
    question:
      "For violating parking regulations, the driver _____ a fine of $200.",
    choices: {
      A: "fined",
      B: "was fined",
    },
    correctAnswer: "B",
    explanation: "A: 운전자가 부과했다 벌금을 B: 운전자가 부과받았다 벌금을",
    translation:
      "주차 규정 위반으로 인해, 운전자가 200달러의 벌금을 부과받았다.",
    type: "voice",
  },
  {
    id: 15,
    koreanQuestion:
      "연회에서, 손님들이 _______  선택을 고급요리 준비된 유명 셰프에 의해",
    question:
      "At the banquet, the guests _____ a selection of gourmet dishes prepared by a renowned chef.",
    choices: {
      A: "served",
      B: "were served",
    },
    correctAnswer: "B",
    explanation: "A: 손님들이 제공했다 선택을 B: 손님들이 제공받았다 선택을",
    translation:
      "연회에서, 손님들이 유명 셰프가 준비한 고급 요리 선택을 제공받았다.",
    type: "voice",
  },
  {
    id: 16,
    koreanQuestion: " 신청 절차 완료후, 직원이  _______ 공식 사원증을",
    question:
      "Upon completing the application process, the employee _____ an official company ID.",
    choices: {
      A: "issued",
      B: "was issued",
    },
    correctAnswer: "B",
    explanation:
      "A: 직원이  발급했다 공식 사원증을 B: 직원이 사원증을 발급받았다 공식 사원증을",
    translation: "신청 절차 완료 후, 직원이 공식 사원증을 발급받았다.",
    type: "voice",
  },
  {
    id: 17,
    koreanQuestion: "병원에서, 환자가  _______  필요한 약을 담당 의사에 의해",
    question:
      "At the hospital, the patient _____ the necessary medication by the attending physician.",
    choices: {
      A: "administered",
      B: "was administered",
    },
    correctAnswer: "B",
    explanation:
      "A: 환자가 투여했다 필요한 약을 B: 환자가 투여받았다 필요한 약을",
    translation: "병원에서, 환자가 담당 의사에 의해 필요한 약을 투여받았다.",
    type: "voice",
  },
  {
    id: 18,
    koreanQuestion: "재정 분쟁 해결 후, 전직 직원이  _______  퇴직금 패키지를",
    question:
      "After the settlement of the financial dispute, the former employee _____ a severance package.",
    choices: {
      A: "owed",
      B: "was owed",
    },
    correctAnswer: "B",
    explanation:
      "A: 전직 직원이 냈다 퇴직금 패키지를 B: 전직 직원이 받게 되었다 퇴직금 패키지를",
    translation: "재정 분쟁 해결 후, 전직 직원이 퇴직금 패키지를 받게 되었다.",
    type: "voice",
  },
  {
    id: 19,
    koreanQuestion:
      "연례 시상식 동안, 우수 직원이  _______ 인증서를 우수성 그녀의 헌신에 대해",
    question:
      "During the annual awards ceremony, the outstanding employee _____ a certificate of excellence for her dedication.",
    choices: {
      A: "presented",
      B: "was presented",
    },
    correctAnswer: "B",
    explanation:
      "A: 우수 직원이 수여했다  인증서를 B: 우수 직원이 수여받았다 인증서를",
    translation:
      "연례 시상식 동안, 우수 직원이 그녀의 헌신에 대해 우수성 인증서를 수여받았다.",
    type: "voice",
  },
  {
    id: 20,
    koreanQuestion: "요청에 따라, 수정된 계약서가 _____ 고객에게 검토를 위해",
    question:
      "Upon request, the revised contract _____ to the client for review.",
    choices: {
      A: "delivered",
      B: "was delivered",
    },
    correctAnswer: "B",
    explanation:
      "A: 수정된 계약서가 전달했다 고객에게 B: 수정된 계약서가 전달되었다 고객에게",
    translation:
      "요청에 따라, 수정된 계약서가 검토를 위해 고객에게 전달되었다.",
    type: "voice",
  },
  {
    id: 21,
    koreanQuestion:
      "그의 심각한 상태로 인해, 환자가  _______ 전문의에게 추가 진단을 위해",
    question:
      "Due to his serious condition, the patient _____ a specialist for further diagnosis.",
    choices: {
      A: "referred",
      B: "was referred",
    },
    correctAnswer: "B",
    explanation:
      "A: 환자가 의뢰했다 전문의에게 B: 환자가 의뢰되었다 전문의에게",
    translation:
      "그의 심각한 상태로 인해, 환자가 추가 진단을 위해 전문의에게 의뢰되었다.",
    type: "voice",
  },
  {
    id: 22,
    koreanQuestion:
      "향상시키기 위해 운영 효율성을, 추가 자금이 _______ 연구부서에",
    question:
      "To improve operational efficiency, additional funding _____ to the research department.",
    choices: {
      A: "allocated",
      B: "was allocated",
    },
    correctAnswer: "B",
    explanation:
      "A: 추가 자금이 할당했다 연구부서에 B: 추가 자금이 할당되었다 연구부서에",
    translation:
      "운영 효율성을 향상시키기 위해, 추가 자금이 연구부서에 할당되었다.",
    type: "voice",
  },
  {
    id: 23,
    koreanQuestion:
      "그들의 공헌에 대한 감사의 표시로, 모든 행사 참가자들이  _______  무료 이용권을 VIP라운지에 대해",
    question:
      "In appreciation of their contributions, all event participants _____ a complimentary pass to the VIP lounge.",
    choices: {
      A: "extended",
      B: "were extended",
    },
    correctAnswer: "B",
    explanation:
      "A: 참가자들이 제공했다 무료 이용권을 B: 참가자들이 제공받았다 무료 이용권을",
    translation:
      "그들의 공헌에 대한 감사의 표시로, 모든 행사 참가자들이 VIP 라운지 무료 이용권을 제공받았다.",
    type: "voice",
  },
  {
    id: 24,
    koreanQuestion:
      "여러 불만 제기 이후, 불만족한 고객들이 _______ 전체 구매 금액을",
    question:
      "Following multiple complaints, the dissatisfied customers _____ their full purchase amount.",
    choices: {
      A: "refunded",
      B: "were refunded",
    },
    correctAnswer: "B",
    explanation:
      "A: 고객들이 환불했다 전체 구매 금액을 B: 고객들이 환불받았다 전체 구매 금액을",
    translation:
      "여러 불만 제기 이후, 불만족한 고객들이 전체 구매 금액을 환불받았다.",
    type: "voice",
  },
  {
    id: 25,
    koreanQuestion: "모든 정규직 직원들이 _______ 월급을 마지막 영업일에 매달",
    question:
      "All full-time employees _____ a monthly salary on the last business day of each month.",
    choices: {
      A: "paid",
      B: "were paid",
    },
    correctAnswer: "B",
    explanation: "A: 직원들이 지급했다 월급을 B: 직원들이 지급받았다 월급을",
    translation: "모든 정규직 직원들이 매달 마지막 영업일에 월급을 지급받았다.",
    type: "voice",
  },
  {
    id: 26,
    koreanQuestion:
      "여러 차례의 협상 이후, 구직자가  _______  경쟁력 있는 급여 패키지를",
    question:
      "After several rounds of negotiations, the job applicant _____ a competitive salary package.",
    choices: {
      A: "offered",
      B: "was offered",
    },
    correctAnswer: "B",
    explanation:
      "A: 구직자가 제안했다 급여 패키지를 B: 구직자가 제안받았다 급여 패키지를",
    translation:
      "여러 차례의 협상 이후, 구직자가 경쟁력 있는 급여 패키지를 제안받았다.",
    type: "voice",
  },
  {
    id: 27,
    koreanQuestion: "확인 이메일이  _______  고객에게 즉시 주문이 접수된 후",
    question:
      "A confirmation email _____ to the customer immediately after the order was placed.",
    choices: {
      A: "sent",
      B: "was sent",
    },
    correctAnswer: "B",
    explanation:
      "A: 확인 이메일이 보냈다 고객에게 B: 확인 이메일이 보내졌다 고객에게",
    translation: "주문이 접수된 후 즉시 확인 이메일이 고객에게 발송되었다.",
    type: "voice",
  },
  {
    id: 28,
    koreanQuestion:
      "보장하기 위해 신속한 응답을, 긴급 요청이  _______  부서장에게",
    question:
      "To ensure a prompt response, the urgent request _____ to the department head.",
    choices: {
      A: "forwarded",
      B: "was forwarded",
    },
    correctAnswer: "B",
    explanation:
      "A: 긴급 요청이 전달했다 부서장에게 B: 긴급 요청이 전달되었다 부서장에게",
    translation:
      "신속한 응답을 보장하기 위해, 긴급 요청이 부서장에게 전달되었다.",
    type: "voice",
  },
  {
    id: 29,
    koreanQuestion: "직원들이  _______  들었을 때  예상치 못한 해고에 대해",
    question:
      "The employees _____ when they heard about the unexpected layoffs.",
    choices: {
      A: "shocked",
      B: "were shocked",
    },
    correctAnswer: "B",
    explanation: "A: 직원들이 충격을 주었다 B: 직원들이 충격을 받았다",
    translation: "직원들이 예상치 못한 해고에 대해 들었을 때 충격을 받았다.",
    type: "voice",
  },
  {
    id: 30,
    koreanQuestion: "나는  _______ 최근 정책 변화에 대해  회사의",
    question: "I _____ about the latest policy changes in the company.",
    choices: {
      A: "confused",
      B: "am confused",
    },
    correctAnswer: "B",
    explanation: "A: 내가 혼란스럽게 했다 B: 나는 혼란스럽다",
    translation: "나는 회사의 최근 정책 변화에 대해 혼란스러웠다.",
    type: "voice",
  },
  {
    id: 31,
    koreanQuestion: "그녀는  _______  일한 후 12시간동안 연속으로",
    question: "She _____ after working for 12 hours straight.",
    choices: {
      A: "exhausted",
      B: "was exhausted",
    },
    correctAnswer: "B",
    explanation: "A: 그녀가 지치게 했다 B: 그녀가 지쳤다",
    translation: "그녀는 12시간 연속으로 일한 후 지쳤다.",
    type: "voice",
  },
  {
    id: 32,
    koreanQuestion: "아이들이  _______ 새로운 상호작용 학습 자료와 함께",
    question: "The children _____ with the new interactive learning materials.",
    choices: {
      A: "interested",
      B: "were interested",
    },
    correctAnswer: "B",
    explanation: "A: 아이들이 관심을 끌었다 B: 아이들이 관심을 가졌다",
    translation: "아이들이 새로운 상호작용 학습 자료에 관심을 보였다.",
    type: "voice",
  },
  {
    id: 33,
    koreanQuestion: "그는  _______  자신의 성과에 기말고사에서",
    question: "He _____ with his performance on the final exam.",
    choices: {
      A: "satisfied",
      B: "was satisfied",
    },
    correctAnswer: "B",
    explanation: "A: 그가 만족시켰다 B: 그가 만족했다",
    translation: "그는 기말고사에서의 자신의 성과에 만족했다.",
    type: "voice",
  },
  {
    id: 34,
    koreanQuestion:
      "승객들이  _______  그들이 알았을 때 그.. 그들의 항공편이 (과거에) 취소되었다는 것을",
    question:
      "The passengers _____ when they learned that their flight had been canceled.",
    choices: {
      A: "frustrated",
      B: "were frustrated",
    },
    correctAnswer: "B",
    explanation: "A: 승객들이 좌절시켰다 B: 승객들이 좌절했다",
    translation:
      "승객들이 그들의 항공편이 취소되었다는 것을 알았을 때 좌절감을 느꼈다.",
    type: "voice",
  },
  {
    id: 35,
    koreanQuestion: "나는  _______  매니저의 무례한 발언에 의해 회의 중에",
    question: "I _____ by the manager's rude remarks during the meeting.",
    choices: {
      A: "embarrassed",
      B: "was embarrassed",
    },
    correctAnswer: "B",
    explanation: "A: 내가 당황하게 했다 B: 내가 당황했다",
    translation: "나는 회의 중에 매니저의 무례한 발언에 당황했다.",
    type: "voice",
  },
  {
    id: 36,
    koreanQuestion: "그는  _______   그가 보았을 때 최종 점수를 경기 ",
    question: "He _____ when he saw the final score of the game.",
    choices: {
      A: "disappointed",
      B: "was disappointed",
    },
    correctAnswer: "B",
    explanation: "A: 그가 실망시켰다 B: 그가 실망했다",
    translation: "그는 경기의 최종 점수를 보았을 때 실망했다.",
    type: "voice",
  },
  {
    id: 37,
    koreanQuestion:
      "그는  _______  그가 알았을 때  그의 항공편이 (과거에) 지연되었다는 것을  6시간 동안",
    question:
      "He _____ when he found out his flight had been delayed for six hours.",
    choices: {
      A: "annoyed",
      B: "was annoyed",
    },
    correctAnswer: "B",
    explanation: "A: 그는 짜증나게 했다 B: 그는 짜증났다",
    translation:
      "그는 그의 항공편이 6시간 지연되었다는 것을 알았을 때 짜증이 났다.",
    type: "voice",
  },
  {
    id: 38,
    koreanQuestion:
      "코미디언의 농담이 예상치 못했다, 그리고 그것은  _______ 듣기에",
    question: "The comedian's joke was unexpected, and it was _____ to hear.",
    choices: {
      A: "embarrassing",
      B: "embarrassed",
    },
    correctAnswer: "A",
    explanation: "A: 농담이 당황하게 만들었다  B: 농담이 당황했다",
    translation: "코미디언의 농담이 예상치 못했고, 그것은 듣기에 당황스러웠다.",
    type: "voice",
  },
  {
    id: 39,
    koreanQuestion: "장관을 이루는 전망이 산 정상에서부터 완전히  _______ .",
    question:
      "The breathtaking view from the top of the mountain was absolutely _____.",
    choices: {
      A: "amazing",
      B: "amazed",
    },
    correctAnswer: "A",
    explanation: "A: 전망이 놀라움을 주는 B: 전망이 놀란",
    translation: "산 정상에서의 장관을 이루는 전망은 완전히 놀라웠다.",
    type: "voice",
  },
  {
    id: 40,
    koreanQuestion: " 연설이 시상식에서 너무 감동적이어서 그 ..____ 듣기에 ",
    question:
      "The speech at the award ceremony was so emotional that it was _____ to listen to.",
    choices: {
      A: "touching",
      B: "touched",
    },
    correctAnswer: "A",
    explanation: "A: 연설이 감동적이었다 B: 연설이 감동받았다",
    translation: "시상식에서의 연설이 매우 감동적이어서 듣기에 감동적이었다.",
    type: "voice",
  },
  {
    id: 41,
    koreanQuestion:
      "변화가 회사의 정책안에서의 예상치 못했었다 그리고 ____ 많은 직원들에게",
    question:
      "The changes in the company's policy were unexpected and were _____ for many employees.",
    choices: {
      A: "surprising",
      B: "surprised",
    },
    correctAnswer: "A",
    explanation: "A: 변화가 놀라움을 주었다 B: 변화가 놀랬다",
    translation: "회사 정책의 변화가 예상치 못했고 많은 직원들에게 놀라웠다.",
    type: "voice",
  },
  {
    id: 42,
    koreanQuestion:
      "교수가  _______  여러 연구들을 뒷받침하기 위해 그의 주장을",
    question: "The professor _____ several studies to support his argument.",
    choices: {
      A: "referred to",
      B: "was referred to",
    },
    correctAnswer: "A",
    explanation:
      "A: 교수가 언급했다 여러 연구를  B: 교수가 언급되었다 여러연구를",
    translation: "교수가 그의 주장을 뒷받침하기 위해 여러 연구를 언급했다.",
    type: "voice",
  },

  {
    id: 43,
    koreanQuestion: "지원자가  _______ 직책에 마케팅 부서의 지난주에",
    question:
      "The applicant _____ the position at the marketing department last week.",
    choices: {
      A: "applied for",
      B: "was applied for",
    },
    correctAnswer: "A",
    explanation: "A: 지원자가 지원했다 B: 지원자가 지원되었다",
    translation: "지원자가 지난주에 마케팅 부서의 직책에 지원했다.",
    type: "voice",
  },

  {
    id: 44,
    koreanQuestion: "과학자가  _______  요인들을 그.. 초래한 기후 변화를",
    question: "The scientist _____ the factors that led to climate change.",
    choices: {
      A: "accounted for",
      B: "was accounted for",
    },
    correctAnswer: "A",
    explanation: "A: 과학자가 설명했다 B: 과학자가 설명되었다",
    translation: "과학자가 기후 변화를 초래한 요인들을 설명했다.",
    type: "voice",
  },
  {
    id: 45,
    koreanQuestion: "직원들이  _______  새로운 회사 정책에  회의 중에",
    question:
      "The employees _____ the new company policies during the meeting.",
    choices: {
      A: "objected to",
      B: "were objected to",
    },
    correctAnswer: "A",
    explanation: "A: 직원들이 반대했다 B: 직원들이 반대되었다",
    translation: "직원들이 회의 중에 새로운 회사 정책에 반대했다.",
    type: "voice",
  },

  {
    id: 46,
    koreanQuestion:
      "많은 전문가들이  _______  세계적 불황에 경제 위기와 관련하여",
    question: "Many experts _____ the economic crisis on the global recession.",
    choices: {
      A: "depended on",
      B: "were depended on",
    },
    correctAnswer: "A",
    explanation: "A: 전문가들이 의존했다 B: 전문가들이 의존되었다",
    translation: "많은 전문가들이 경제 위기와 관련하여 세계적 불황에 의존했다.",
    type: "voice",
  },

  {
    id: 47,
    koreanQuestion: "회사가  _______ 팀  숙련된 전문가들의",
    question: "The company _____ a team of skilled professionals.",
    choices: {
      A: "consists of",
      B: "is consisted of",
    },
    correctAnswer: "A",
    explanation:
      "A: 회사가 구성되어 있다(자체가 수동적 의미) B: (문법적으로 틀림)",
    translation: "회사가 숙련된 전문가들로 구성된 팀으로 이루어져 있다.",
    type: "voice",
  },
  {
    id: 48,
    koreanQuestion: "그녀는  _______  상사의 조언을 그리고 수정했다 보고서를 ",
    question: "She _____ her supervisor's advice and revised the report.",
    choices: {
      A: "listened to",
      B: "was listened to",
    },
    correctAnswer: "A",
    explanation: "A: 그녀는 들었다 B: 그녀는 들려졌다",
    translation: "그녀는 상사의 조언을 듣고 보고서를 수정했다.",
    type: "voice",
  },

  {
    id: 49,
    koreanQuestion: "단체가  _______ 지역사회에 제공함으로써 무료 교육을",
    question:
      "The organization _____ the community by providing free education.",
    choices: {
      A: "contributed to",
      B: "was contributed to",
    },
    correctAnswer: "A",
    explanation: "A: 단체가 기여했다 B: 단체가 기여되었다",
    translation: "단체가 무료 교육을 제공함으로써 지역사회에 기여했다.",
    type: "voice",
  },

  {
    id: 50,
    koreanQuestion: "방문객들이 _______  예술 작품을 몇 분 동안",
    question: "The visitors _____ the artwork for several minutes.",
    choices: {
      A: "looked at",
      B: "were looked at",
    },
    correctAnswer: "A",
    explanation: "A: 방문객들이 바라보았다 B: 방문객들이 바라보아졌다",
    translation: "방문객들이 몇 분 동안 예술 작품을 바라보았다.",
    type: "voice",
  },
  {
    id: 51,
    koreanQuestion:
      "깨달은 후 자신의 실수를, 그는 ____ 그의 동료에게 오해에 대해",
    question:
      "After realizing his mistake, he _____ his colleague for the misunderstanding.",
    choices: {
      A: "apologized for",
      B: "was apologized for",
    },
    correctAnswer: "A",
    explanation: "A: 그는 사과했다 동료에게  B: 그는 사과받았다 동료에게",
    translation: "자신의 실수를 깨달은 후, 그는 오해에 대해 동료에게 사과했다.",
    type: "voice",
  },
  {
    id: 52,
    koreanQuestion: "IT 전문가가  _______  보안 결함을  시스템의",
    question: "The IT specialist _____ a security flaw in the system.",
    choices: {
      A: "looked into",
      B: "was looked into",
    },
    correctAnswer: "A",
    explanation:
      "A: 전문가가 조사했다 보안 결함을 B: 전문가가 조사되었다 보안 결함을",
    translation: "IT 전문가가 시스템의 보안 결함을 조사했다.",
    type: "voice",
  },

  {
    id: 53,
    koreanQuestion: "고객이  _______  환불을 결함이 있는 제품에 대해",
    question: "The customer _____ a refund for the defective product.",
    choices: {
      A: "asked for",
      B: "was asked for",
    },
    correctAnswer: "A",
    explanation: "A: 고객이 요청했다 B: 고객이 요청받았다",
    translation: "고객이 결함이 있는 제품에 대해 환불을 요청했다.",
    type: "voice",
  },
  {
    id: 54,
    koreanQuestion: "투자자들이  _______  위험을 승인하기 전에 프로젝트를",
    question: "The investors _____ the risks before approving the project.",
    choices: {
      A: "reflected on",
      B: "were reflected on",
    },
    correctAnswer: "A",
    explanation: "A: 투자자들이 숙고했다 B:투자자들이 숙고되었다",
    translation: "투자자들이 프로젝트를 승인하기 전에 위험을 숙고했다.",
    type: "voice",
  },
  {
    id: 55,
    koreanQuestion: "매니저가  _______  직원 만족도에 대해 면접 중에",
    question:
      "The manager _____ about employee satisfaction during the interview.",
    choices: {
      A: "inquired",
      B: "was inquired",
    },
    correctAnswer: "A",
    explanation: "A:매니저가 문의했다 B: 매니저가 문의받았다",
    translation: "매니저가 면접 중에 직원 만족도에 대해 문의했다.",
    type: "voice",
  },
  {
    id: 56,
    koreanQuestion: "회사가  _______ 개발을 AI 기반 보안 시스템",
    question:
      "The company _____ the development of AI-powered security systems.",
    choices: {
      A: "specializes in",
      B: "is specialized in",
    },
    correctAnswer: "A",
    explanation:
      "A: 회사가 전문으로 한다 개발을 B: 회사가 전문화되어 있다 개발을",
    translation: "회사가 AI 기반 보안 시스템 개발을 전문으로 한다.",
    type: "voice",
  },

  {
    id: 57,
    koreanQuestion:
      "관객들이  _______  코미디언의 농담에 그리고 터뜨렸다 웃음을",
    question:
      "The audience _____ at the comedian's joke and burst into laughter.",
    choices: {
      A: "laughed",
      B: "were laughed",
    },
    correctAnswer: "A",
    explanation:
      "A: 관객들이 웃었다 코미디언의 농담에 B:  관객들이 웃음을 받았다 코미디언의 농담에",
    translation: "관객들이 코미디언의 농담에 웃고 웃음을 터뜨렸다.",
    type: "voice",
  },

  {
    id: 58,
    koreanQuestion:
      "고객 서비스 팀이  _______  불만들을 고객들로부터 전문적으로",
    question:
      "The customer service team _____ complaints from customers professionally.",
    choices: {
      A: "deals with",
      B: "is dealt with",
    },
    correctAnswer: "A",
    explanation: "A: 처리한다 B: 처리된다",
    translation: "고객 서비스 팀이 고객들의 불만을 전문적으로 처리한다.",
    type: "voice",
  },

  {
    id: 59,
    koreanQuestion: "CEO가  직접  _______  이메일에 투자자로부터 온",
    question: "The CEO personally _____ to the emails from investors.",
    choices: {
      A: "replied",
      B: "was replied",
    },
    correctAnswer: "A",
    explanation: "A: 답변했다 B: 답변받았다",
    translation: "CEO가 직접 투자자들의 이메일에 답변했다.",
    type: "voice",
  },

  {
    id: 60,
    koreanQuestion: "대부분의 직원들이  _______  새로운 직장 정책에",
    question: "Most employees _____ with the new workplace policies.",
    choices: {
      A: "agree",
      B: "are agreed",
    },
    correctAnswer: "A",
    explanation: "A: 동의한다 B: 동의된다",
    translation: "대부분의 직원들이 새로운 직장 정책에 동의한다.",
    type: "voice",
  },

  {
    id: 61,
    koreanQuestion: "이 부동산이  _______  유명한 부동산 개발업자에게",
    question: "This property _____ to a well-known real estate developer.",
    choices: {
      A: "belongs",
      B: "is belonged",
    },
    correctAnswer: "A",
    explanation: "A: 속해있다 B: 속해져 있다",
    translation: "이 부동산은 유명한 부동산 개발업자에게 속해있다.",
    type: "voice",
  },

  {
    id: 62,
    koreanQuestion: "많은 환경운동가들이  _______  사용에 플라스틱 제품 ",
    question:
      "Many environmental activists _____ to the use of plastic products.",
    choices: {
      A: "object",
      B: "are objected",
    },
    correctAnswer: "A",
    explanation: "A: 반대한다 B: 반대된다",
    translation: "많은 환경운동가들이 플라스틱 제품의 사용에 반대한다.",
    type: "voice",
  },
  {
    id: 63,
    koreanQuestion: "기차가  _______  역으로 부터  정확히 정시에",
    question: "The train _____ from the station exactly on time.",
    choices: {
      A: "is arrived",
      B: "arrived",
    },
    correctAnswer: "B",
    explanation: "A: 기차가 도착된다 B: 기차가 ㄴ도착했다",
    translation: "기차가 정확히 정시에 역에서 출발했다.",
    type: "voice",
  },

  {
    id: 64,
    koreanQuestion: "레스토랑이  _______ 11시에  매일 밤",
    question: "The restaurant _____ at 11 PM every night.",
    choices: {
      A: "is closed",
      B: "closes",
    },
    correctAnswer: "B",
    explanation: "A: 레스토랑이 닫힌다 B: 레스토랑이 닫는다",
    translation: "레스토랑이 매일 밤 11시에 문을 닫는다.",
    type: "voice",
  },

  {
    id: 65,
    koreanQuestion: "정문이  _______  자동으로  누군가 다가올 때",
    question: "The main entrance _____ automatically when someone approaches.",
    choices: {
      A: "is opened",
      B: "opens",
    },
    correctAnswer: "A",
    explanation: "A: 정문이 열린다 B: 정문이 열었다",
    translation: "정문이 누군가 다가올 때 자동으로 열린다.",
    type: "voice",
  },

  {
    id: 66,
    koreanQuestion: "손님들이  _______  행사장에 더 일찍  예상보다 ",
    question: "The guests _____ at the venue earlier than expected.",
    choices: {
      A: "are arrived",
      B: "arrived",
    },
    correctAnswer: "B",
    explanation: "A: 손님들이 도착된다 B:손님들이 도착했다",
    translation: "손님들이 예상보다 일찍 행사장에 도착했다.",
    type: "voice",
  },

  {
    id: 67,
    koreanQuestion: "태양이  _______  산들 뒤로  저녁이 되면서",
    question: "The sun _____ behind the mountains as the evening set in.",
    choices: {
      A: "is disappeared",
      B: "disappeared",
    },
    correctAnswer: "B",
    explanation: "A: 태양이 사라진다 B: 태양이 사라졌다",
    translation: "저녁이 되면서 태양이 산들 뒤로 사라졌다.",
    type: "voice",
  },

  {
    id: 68,
    koreanQuestion: "그 가게는  _______  오전 9시에 평일에 ",
    question: "The store _____ at 9 AM on weekdays.",
    choices: {
      A: "is opened",
      B: "opens",
    },
    correctAnswer: "B",
    explanation: "A: 그 가게는 열린다 B: 그 가게는 연다",
    translation: "그 가게는 평일에 오전 9시에 문을 연다.",
    type: "voice",
  },

  {
    id: 69,
    koreanQuestion: "사무실 건물이  _______ 오후 8시에  보안상의 이유로",
    question: "The office building _____ at 8 PM for security reasons.",
    choices: {
      A: "is closed",
      B: "closes",
    },
    correctAnswer: "B",
    explanation: "A:사무실 건물이 닫힌다 B: 사무실 건물이 닫는다",
    translation: "사무실 건물이 보안상의 이유로 오후 8시에 문을 닫는다.",
    type: "voice",
  },
  {
    id: 70,
    koreanQuestion:
      "보고서가 _______ 매달 확실히 하기 위해 그.. 최신 정보가 포함되도록 ",
    question:
      "The report _____ every month to ensure the latest information is included.",
    choices: {
      A: "updates",
      B: "is updated",
    },
    correctAnswer: "B",
    explanation: "A: 보고서가 업데이트한다 B: 보고서가 업데이트된다",
    translation: "보고서가 최신 정보가 포함되도록 하기 위해 매달 업데이트된다.",
    type: "voice",
  },
  {
    id: 71,
    koreanQuestion:
      "지친 그녀의 길고 ____ 한 비행으로부터, 윌리엄스씨는 쉬었다 호텔 방에서",
    question:
      "Tired from her long and _____ flight, Ms. Williams rested in her hotel room.",
    choices: {
      A: "exhausting",
      B: "exhausted",
    },
    correctAnswer: "A",
    explanation: "A: 그녀의 지치게 만드는 비행 B: 그녀의 지친 비행 ",
    translation:
      "그녀의 길고 지치게 만드는 비행으로 지친 윌리엄스 씨는 호텔 방에서 쉬었다.",
    type: "voice",
  },
  {
    id: 72,
    koreanQuestion:
      "모든 직원들이  _______ 새로운 회사 정책에 대해 오리엔테이션 세션 동안",
    question:
      "All employees _____ on the new company policies during the orientation session.",
    choices: {
      A: "were updated",
      B: "updating",
    },
    correctAnswer: "A",
    explanation:
      "A: 모든 직원들이 업데이트 받았다 B: 모든 직원들이 업데이트하고 있는",
    translation:
      "모든 직원들이 오리엔테이션 세션 동안 새로운 회사 정책에 대해 안내받았다.",
    type: "voice",
  },
  {
    id: 73,
    koreanQuestion: "보고서는 _____ 감독관에 의해 매주 금요일에",
    question: "The report __________ by the supervisor every Friday.",
    choices: {
      A: "checks",
      B: "is checked",
    },
    correctAnswer: "B",
    explanation: "A: 보고서는 확인한다 B: 보고서는 확인된다",
    translation: "보고서는 매주 금요일에 감독관에 의해 확인된다.",
    type: "voice",
  },
  {
    id: 74,
    koreanQuestion: "그녀는 보통 ____  회의록을 회의 후에",
    question: "She usually _____ the minutes after the meeting.",
    choices: {
      A: "writes",
      B: "is written",
    },
    correctAnswer: "A",
    explanation: "A: 그녀가 직접 쓴다 B: 그녀가 쓰여진다 ",
    translation: "그녀는 보통 회의 후에 회의록을 작성한다.",
    type: "voice",
  },
  {
    id: 75,
    koreanQuestion: "이메일들은 _____ 매일 아침에",
    question: "The emails ______ every morning.",
    choices: {
      A: "send",
      B: "are sent",
    },
    correctAnswer: "B",
    explanation: "A: 보낸다 B: 보내진다",
    translation: "이메일들은 매일 아침에 보내진다.",
    type: "voice",
  },
];
